import React from "react";
import {
  StructuredListWrapper,
  StructuredListHead,
  StructuredListCell,
  StructuredListRow,
  StructuredListBody,
} from "@carbon/react";
import { NoDataToSeeContainer } from "../NoDataToSeeContainer";

export const View = (props) => {
  return (
    <div>
      <StructuredListWrapper isCondensed={props.isCondensed}>
        <StructuredListHead>{props.headers}</StructuredListHead>

        {props.rows === null ? "" : props.rows}
      </StructuredListWrapper>

      {props.rows === null ? (
        <NoDataToSeeContainer errorMessage="No data available..." />
      ) : (
        ""
      )}
    </div>
  );
};
